/**
 * SGKC030A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Sgkc030aReqAdjustmentunitfeeNoticeShutokuinfoDto {

    /**
     * 契約お客さま番号
     */
    firstSrvctrNo?: string;
    /**
     * サービス種別コード
     */
    srvClsfyCode?: string;
    /**
     * 対象年月
     */
    kkChargeCalcYm?: string;
}

